import axios from "axios";

const API_BASE =
  process.env.REACT_APP_API_BASE_URL || "https://modularobjects.com";

const API = `${API_BASE}/marketing/api/erp/master-data`;

function authHeader(token) {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

export async function fetchResourceTypes(token) {
  const res = await axios.get(`${API}/resource-types`, authHeader(token));
  return res.data;
}

export async function fetchCategories(token) {
  const res = await axios.get(`${API}/categories`, authHeader(token));
  return res.data;
}

export async function fetchUom(token) {
  const res = await axios.get(`${API}/uom`, authHeader(token));
  return res.data;
}

export async function fetchLocations(token) {
  const res = await axios.get(`${API}/locations`, authHeader(token));
  return res.data;
}

export async function fetchWarehouses(token) {
  const res = await axios.get(`${API}/warehouses`, authHeader(token));
  return res.data;
}

export async function fetchPartners(token) {
  const res = await axios.get(`${API}/partners`, authHeader(token));
  return res.data;
}

export async function fetchResourceItems(token, params = {}) {
  const res = await axios.get(`${API}/resource-items`, {
    ...authHeader(token),
    params,
  });
  return res.data;
}

export async function createResourceItem(token, data) {
  const res = await axios.post(
    `${API}/resource-items`,
    data,
    authHeader(token)
  );
  return res.data;
}

export async function updateResourceItem(token, id, data) {
  const res = await axios.patch(
    `${API}/resource-items/${id}`,
    data,
    authHeader(token)
  );
  return res.data;
}

export async function fetchResourceItemById(token, id) {
  const res = await axios.get(
    `${API}/resource-items/${id}`,
    authHeader(token)
  );
  return res.data;
}

export async function fetchSupplierSources(token) {
  const res = await axios.get(`${API}/supplier-sources`, authHeader(token));
  return res.data;
}

export async function fetchDecors(token) {
  const res = await axios.get(`${API}/decors`, authHeader(token));
  return res.data;
}

export async function createDecor(token, data) {
  const res = await axios.post(`${API}/decors`, data, authHeader(token));
  return res.data;
}

export async function updateDecor(token, id, data) {
  const res = await axios.patch(`${API}/decors/${id}`, data, authHeader(token));
  return res.data;
}

export async function fetchItemAttributes(token) {
  const res = await axios.get(`${API}/item-attributes`, authHeader(token));
  return res.data;
}

export async function createItemAttribute(token, data) {
  const res = await axios.post(`${API}/item-attributes`, data, authHeader(token));
  return res.data;
}

export async function updateItemAttribute(token, id, data) {
  const res = await axios.patch(`${API}/item-attributes/${id}`, data, authHeader(token));
  return res.data;
}

export async function fetchResourceItemFull(token, id) {
  const res = await axios.get(`${API}/resource-items/${id}/full`, authHeader(token));
  return res.data;
}

export async function updateResourceItemFull(token, id, data) {
  const res = await axios.patch(`${API}/resource-items/${id}/full`, data, authHeader(token));
  return res.data;
}

export async function uploadResourceItemImage(token, itemId, file, meta = {}) {
  const formData = new FormData();
  formData.append("image", file);
  if (meta.image_type) formData.append("image_type", meta.image_type);
  if (meta.sort_order !== undefined) formData.append("sort_order", meta.sort_order);
  if (meta.is_primary !== undefined) formData.append("is_primary", meta.is_primary);

  const res = await axios.post(
    `${API}/resource-items/${itemId}/images/upload`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return res.data;
}

export async function updateResourceItemImage(token, imageId, data) {
  const res = await axios.patch(`${API}/resource-items/images/${imageId}`, data, authHeader(token));
  return res.data;
}

export async function deleteResourceItemImage(token, imageId) {
  const res = await axios.delete(`${API}/resource-items/images/${imageId}`, authHeader(token));
  return res.data;
}

export async function uploadDecorImage(token, decorId, file) {
  const formData = new FormData();
  formData.append("image", file);

  const res = await axios.post(
    `${API}/decors/${decorId}/image/upload`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return res.data;
}

export async function exportResourceItemsCsv(token, params = {}) {
  const res = await axios.get(`${API}/resource-items/export.csv`, {
    ...authHeader(token),
    params,
    responseType: "blob",
  });
  return res.data;
}

export async function importResourceItemsCsv(token, file) {
  const formData = new FormData();
  formData.append("file", file);

  const res = await axios.post(`${API}/resource-items/import.csv`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });

  return res.data;
}